<template>
   <HeaderDash />
   <SideMenu /> 
   <ContentAddProject /> 
</template>
<script>
// Importando los componententes pertenecientes a esta vista
import HeaderDash from '@/components/worker/dashboard/HeaderDash.vue'
import SideMenu from '@/components/worker/dashboard/SideMenu.vue'
import ContentAddProject from '@/components/worker/dashboard/modules/project/ContentAddProject.vue'

export default 
{
  name: 'AddProject',
  components: 
  {
    HeaderDash,
    SideMenu,
    ContentAddProject
  }
}
</script>
<style>

</style>
